import React, { Component } from 'react'
import Settings from '../context/settings'
import styled, { css } from 'styled-components';

const AppHeader = styled(({ settings, ...props }) => (
    <div {...props}></div>
))`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    ${({ settings }) => css`
        height: ${settings.common.header.scale * 7.25}rem;
    
        background-image: url('${settings.logo}');   
        background-size: ${settings.common.header.stretch ? 'cover' : 'contain'};
        background-position: ${settings.common.header.attach};
        background-repeat: no-repeat;

        ${settings.mode === 'sample' ? 'margin: 1rem;' : ''}
    `}

    border-width: 0;
    border-style: solid;
    border-top-right-radius: 9px;
    border-top-left-radius: 9px;

    img {
        display: inline-block;
        position: static;
        width: 6rem;
        height: auto;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    h1 {
        display: inline-block;
        position: static;
        width: auto;
        height: auto;
        font-family: 'Montserrat Alternates', sans-serif;
        font-weight: lighter;
        font-size: 5rem;
        padding-left: 1rem;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
`;

export default class Header extends Component {
    render() {
        return (
            // Pick up the logo from the global settings context
            <Settings.Consumer>
                {({ mode, logo, common }) => mode !== 'plugin' && !!logo ? (
                    // Set the image dynamically
                    <AppHeader
                        settings={{
                            mode,
                            logo,
                            common
                        }}
                    >
                    </AppHeader>
                ) : null}
            </Settings.Consumer>
        );
    }
}
